
<template>
  <div class="page with-navbar">
    <div class="only-desktop">
      <top-bar></top-bar>
    </div>
    <rebuild-nav-bar></rebuild-nav-bar>

    <div class="protocol-container">
      <h1 class="protocol-title only-mobile">上传须知</h1>
      <div class="desc">
        <p class="mt10">
          本人保证合法上传图片或添加文字，不会以任何形式上传及使用涉及以下内容的图片或文字，包括但不限于此处列举的情况，如因本人上传图片或添加文字造成的不良影响或各类纠纷，一概由本人自行承担全部责任，保乐力加对此概不负责：
        </p>
      </div>

      <p>a)含有国旗、党旗、国徽、国家机关名称、国家机关工作人员名字等涉及政治内容的图片或文字；</p>
      <p>b)有著作权问题的艺术作品图片；</p>
      <p>c)以人民币或其他货币为主题的图片或文字；</p>
      <p>d) 未经授权使用企业标志、企业名称的图片；</p>
      <p>e)含有如宗教、种族歧视、侮辱诽谤他人、色情暴力、泄露商业机密等内容的图片或文字；</p>
      <p>f)出于尊重肖像权的考虑，未经授权请勿上传能清晰看到他人肖像的图片；如有类似情况，请作背景虚化处理后再上传；</p>
      <p>g)危害人身和财产安全，侵犯他人个人隐私的图片或文字；</p>
      <p>h)其他违背社会道德、地方风俗的明示或暗示性的图片或文字。</p>
    </div>

    <page-footer></page-footer>
  </div>
</template>

<script>
import TopBar from '@components/TopBar'
import RebuildNavBar from '@components/RebuildNavBar'
import PageFooter from '@components/PageFooter'

export default {
  name: 'Protocol',
  components: {
    TopBar,
    RebuildNavBar,
    PageFooter,
  },
}
</script>

<style lang="scss" scoped>
.protocol-container {
  padding: 40px 30px;
  text-align: justify;
  font-weight: 500;
  font-size: 1.2rem;
  color: #fff;
  line-height: 180%;
  position: relative;
  @include respond-to(desktop) {
    max-width: 960px;
    margin: 0 auto;
    line-height: 200%;
  }
  .protocol-title {
    margin-bottom: 24px;
    font-weight: 900;
    font-size: 2rem;
    color: #fff;
    opacity: 0.9;
    text-align: center;
    font-family: 'Absolut';
    // text-shadow: 2px 2px 0 nth($, 3);
  }
  .sub-title {
    margin: 24px 0 8px;
    font-weight: bold;
    font-size: 2rem;
    color: #fff;
    text-align: center;
    @include respond-to(desktop) {
      text-align: left;
      font-size: 1.4rem;
    }
  }
  .desc {
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ugc/uploadterms.vue